import React, {useState} from 'react';
import axios from '../Common/axios';
import Papa from "papaparse";
import {Button, Select, Layout, Modal} from "antd";
import {CodeSelect} from '../Common/CodeSelect';
import {getGridTableHeight, isValidate} from '../Common/util';
import {postSaveAssetUpload} from '../Common/api';
import {CSVLink} from 'react-csv';
import { fieldRules, validate } from '../Common/validationObj';
import { strToCamelCase } from '../Common/util';
    
const { Content } = Layout;
const {Option} = Select;


/** -------------------------------------------------------------------------- **/
function AssetUpload({ p_companyCode, p_companyName, p_assetType, p_assetTypeName, onClose }) {

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(p_companyCode);
    const [companyName, setCompanyName] = useState(p_companyName);
    const [assetType, setAssetType] = useState(p_assetType);
    const [assetTypeName, setAssetTypeName] = useState(p_assetTypeName);
    const [uploading, setUploading] = useState(false);
    const [showUpload, setShowUpload] = useState(false);

    // State to store parsed data
    const [parsedData, setParsedData] = useState([]);
    //State to store table Column name
    const [tableRows, setTableRows] = useState([]);
    //State to store the values
    const [values, setValues] = useState([]);
    const [uploadfile, setUploadfile] = useState(null);
    
    const csv_headers = [
        { label: "**", key: "asset_type" },
        { label: "**", key: "asset_cd" },
        { label: "**", key: "asset_nm" },
        { label: "**", key: "asset_spec" },   
        { label: "", key: "os_type" },
        // { label: "", key: "asset_ver" },
        // { label: "", key: "aws_nm" },
        // { label: "", key: "vpc_nm" },
        // { label: "", key: "cluster_nm" },
        { label: "", key: "os_ver" },
        { label: "**", key: "asset_qty" },
        { label: "**", key: "asset_ip" },
        { label: "", key: "public_ip" },
        { label: "", key: "mac_no" },
        { label: "**", key: "ssh_port" },
        { label: "", key: "arch" },
        { label: "", key: "cpu" },
        { label: "**", key: "depart_nm" },
        { label: "**", key: "manager_nm" },
        { label: "**", key: "supervisor_nm" },
        { label: "**", key: "location_nm" },
        { label: "**", key: "service_nm" },
        { label: "**", key: "use_yn" },
        { label: "**", key: "isms_yn" },
        { label: "**", key: "rms_yn" },
        { label: "", key: "remark" },
        { label: "**", key: "confidential_score" },
        { label: "**", key: "integrity_score" },
        { label: "**", key: "availability_score" },
        // { label: "**", key: "asset_grd" },
      ];
      
    const csv_data = [
        { 
            asset_type: "자산구분",
            asset_cd: "자산코드",
            asset_nm: "자산명",
            asset_spec: "자산유형",
            os_type: "OS유형",
            // asset_ver: "Group(사양)",
            // aws_nm: "AWS계정",
            // vpc_nm: "VPC",
            // cluster_nm: "Cluster",
            os_ver: "OS및버전",
            asset_qty: "자산수량(숫자)",
            asset_ip: "IP주소",
            public_ip: "외부IP",
            mac_no: "MAC",
            ssh_port: "SSH Port(숫자)",
            arch: "ARCH",
            cpu: "CPU",
            depart_nm: "담당팀",
            manager_nm: "담당자",
            supervisor_nm: "관리자",
            location_nm: "설치장소",
            service_nm: "용도(서비스)",
            use_yn: "사용여부(Y/N)",
            isms_yn: "ISMS대상(Y/N)",
            rms_yn: "취약점분석(Y/N)",
            remark: "비고",
            confidential_score: "기밀성(숫자)",
            integrity_score: "무결성(숫자)",
            availability_score: "가용성(숫자)"
            // asset_grd: "보안등급(H/M/L)" 
        },
        { 
            asset_type: "asset_type",
            asset_cd: "asset_cd",
            asset_nm: "asset_nm",
            asset_spec: "asset_spec",
            // asset_ver: "asset_ver",
            // aws_nm: "aws_nm",
            // vpc_nm: "vpc_nm",
            // cluster_nm: "cluster_nm",
            os_type: "os_type",
            os_ver: "os_ver",
            asset_qty: "asset_qty",
            asset_ip: "asset_ip",
            public_ip: "public_ip",
            mac_no: "mac_no",
            ssh_port: "ssh_port",
            arch: "arch",
            cpu: "cpu",
            depart_nm: "depart_nm",
            manager_nm: "manager_nm",
            supervisor_nm: "supervisor_nm",
            location_nm: "location_nm",
            service_nm: "service_nm",
            use_yn: "use_yn",
            isms_yn: "isms_yn",
            rms_yn: "rms_yn",
            remark: "remark",
            confidential_score: "confidential_score",
            integrity_score: "integrity_score",
            availability_score: "availability_score"
            // asset_grd: "asset_grd" 
        },
        { 
            asset_type: "LX",
            asset_cd: "LX001",
            asset_nm: "iseweb1",
            asset_spec: "linux",
            // asset_ver: "",
            // aws_nm: "",
            // vpc_nm: "",
            // cluster_nm: "",
            os_type: "Linux",
            os_ver: "",
            asset_qty: "1",
            asset_ip: "192.168.0.11",
            public_ip: "",
            mac_no: "",
            ssh_port: "22",
            arch: "",
            cpu: "",
            depart_nm: "IT본부",
            manager_nm: "홍길동",
            supervisor_nm: "임꺽정",
            location_nm: "서울IDC",
            service_nm: "WEB/WAS",
            use_yn: "Y",
            isms_yn: "Y",
            rms_yn: "Y",
            remark: "",
            confidential_score: "3",
            integrity_score: "3",
            availability_score: "3",
            asset_grd: "H" 
        },
        { 
            asset_type: "LX",
            asset_cd: "LX002",
            asset_nm: "iseweb2",
            asset_spec: "linux",
            // asset_ver: "",
            // aws_nm: "",
            // vpc_nm: "",
            // cluster_nm: "",
            os_type: "Linux",
            os_ver: "",
            asset_qty: "1",
            asset_ip: "192.168.0.12",
            public_ip: "",
            mac_no: "",
            ssh_port: "22",
            arch: "",
            cpu: "",
            depart_nm: "IT본부",
            manager_nm: "홍길동",
            supervisor_nm: "임꺽정",
            location_nm: "서울IDC",
            service_nm: "WEB/WAS",
            use_yn: "Y",
            isms_yn: "Y",
            rms_yn: "Y",
            remark: "",
            confidential_score: "3",
            integrity_score: "3",
            availability_score: "3"
            // asset_grd: "H" 
        },
        { 
            asset_type: "DB",
            asset_cd: "DB001",
            asset_nm: "isewebdb1",
            asset_spec: "mariadb",
            // asset_ver: "",
            // aws_nm: "",
            // vpc_nm: "",
            // cluster_nm: "",
            os_type: "Linux",
            os_ver: "",
            asset_qty: "1",
            asset_ip: "192.168.0.12",
            public_ip: "",
            mac_no: "",
            ssh_port: "22",
            arch: "",
            cpu: "",
            depart_nm: "IT본부",
            manager_nm: "홍길동",
            supervisor_nm: "임꺽정",
            location_nm: "서울IDC",
            service_nm: "DB",
            use_yn: "Y",
            isms_yn: "Y",
            rms_yn: "Y",
            remark: "",
            confidential_score: "3",
            integrity_score: "3",
            availability_score: "3"
            // asset_grd: "H" 
        },
        { asset_type: "" },
        { asset_type: "" },
        { asset_type: "■ 첫 행과 두 번째 행은 칼럼을 설명한 것이니 반드시 삭제해야 합니다." },
        { asset_type: "■ ** 표시가 있는 칼럼은 필수입력으로 반드시 입력해주세요.(입력할게 없으면 '-' 입력)" },
        // { asset_type: "■ 자산구분(DB,LX 기타등) 코드는 한 종류만 입력해 파일 작성해 주세요.(예시는 참고용임 LX 아니면 DB 둘 중 하나만 있어야 합니다.)" },
        { asset_type: "■ 칼럼명 옆에 (Y/N)으로 표시되어 있는 부분은 반드시 Y 또는 N으로 입력해주세요." },
        { asset_type: "■ 칼럼명 옆에 (숫자)로 표시되어 있는 부분은 반드시 숫자로 입력해주세요." },
        // { asset_type: "■ 보안등급은 H/M/L중에서만 입력해주세요." },
    ];

    const titleName="자산등록";
    //----------------------------------------------------------------------------------------
    // 회사코드 변경
    const onChangeCompanyCode = (value) => {
        setCompanyCode(value);
    };

    // 자산유형 변경
    const onChangeAssetType = (value) => {
        setAssetType(value);
    };

    function deepTrim(obj) {
        if (typeof obj === "string") {
            return obj.trim();
        } else if (Array.isArray(obj)) {
            return obj.map(item => deepTrim(item));
        } else if (obj && typeof obj === "object") {
            return Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [key, deepTrim(value)])
            );
        } else {
            return obj;
        }
    }
    // 파일업로드
    const onChangeUploadHandler = (event) => {

        setShowUpload(true);
        setUploadfile(event.target);
        // Passing file data (event.target.files[0]) to parse using Papa.parse
        // Papa.parse(event.target.files[0], {
        //     header: true,
        //     skipEmptyLines: 'greedy',
        //     complete: function (results) {
        //         const rowsArray = [];
        //         const valuesArray = [];

        //         // Iterating data to get column name and their values
        //         results.data.map((d) => {
        //             if(d.os_type){
        //                 d.os_type = d.os_type.charAt(0).toUpperCase()+d.os_type.slice(1).toLowerCase();
        //             }
        //             rowsArray.push(Object.keys(d));
        //             valuesArray.push(Object.values(d));
        //         });

        //         // Parsed Data Response in array format
        //         setParsedData(results.data);

        //         // Filtered Column Names
        //         setTableRows(rowsArray[0]);

        //         // Filtered Values
        //         setValues(valuesArray);

        //     },
        // });

        Papa.parse(event.target.files[0], {
            header: false,
            skipEmptyLines: 'greedy',
            complete: function (results) {
                const rowsArray = [];
                const valuesArray = [];
                const rows = results.data;

                // 예시: 첫 줄이 설명이고 두 번째 줄이 헤더라고 가정
                // let headerRowIndex = 1;

                const startComment = row => row[0].startsWith("**") || row[0].startsWith("자산구분");
                const endComment = row => row[0].startsWith("■");
                let headerRowIndex = rows.findIndex(row => !startComment(row));
                let lastRowIndex = rows.findIndex(row => endComment(row));
                lastRowIndex = lastRowIndex == -1 ? rows.length : lastRowIndex;


                const header = rows[headerRowIndex];
                const dataRows = rows.slice(headerRowIndex + 1, lastRowIndex);

                // 헤더와 데이터를 합쳐 객체 배열 만들기
                const finalData = dataRows.map(row => {
                    const obj = {};
                    
                    if(row[3] && typeof row[3] === 'string'){
                        // row[3] = row[3].charAt(0).toUpperCase()+row[3] .slice(1).toLowerCase();
                        row[3] = strToCamelCase(row[3]);
                    }

                    if(row[4] && typeof row[4] === 'string'){
                        // row[4] = row[4].charAt(0).toUpperCase()+row[4].slice(1).toLowerCase();
                        row[4] = strToCamelCase(row[4]);
                    }
                    header.forEach((key, i) => {
                        obj[key] = row[i];
                    });

                    valuesArray.push(deepTrim(row));
                    return deepTrim(obj);
                });

                setParsedData(finalData); // 내부에서 키를 사용하여 검증및 처리 작업하는 데이터
                setTableRows(header);
                setValues(valuesArray); // 화면에 보여주는 데이터(키가 없는 데이터)

                // results.data.map((d) => {
                //     if(d.os_type){
                //         d.os_type = d.os_type.charAt(0).toUpperCase()+d.os_type.slice(1).toLowerCase();
                //     }
                //     rowsArray.push(Object.keys(d));
                //     valuesArray.push(Object.values(d));
                // });

                // // Parsed Data Response in array format
                // setParsedData(results.data);

                // // Filtered Column Names
                // setTableRows(rowsArray[0]);

                // // Filtered Values
                // setValues(valuesArray);

            },
        });        
    };

    // 파일 Key값 체크
    function isKeyCheckError(element) {
        //if(element.com_cd != companyCode) {
        //    return true;
        //} 
        //자산 조건이 있는 경우에만 체크
        if(assetType != "" && element.asset_type != assetType) {
            return true;
        } 
        return false;
    };

    // 저장
    const onClickSaveHandler = () => {

        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사 조건은 필수입니다."});
            return;
        }

        uploadfile.value=null;
        // if (assetType == '') {
        //     Modal.info({title: "자산구분을 선택해 주세요."});
        //     return;
        // }

        const checkData = async() => {
            const errormsg = [];
            const seen = new Set(); 
            const assetKey = "asset_cd";

            for(let item of parsedData){

                if (seen.has(item[assetKey])) {
                    errormsg.push(item[assetKey] + " -> 중복된 자산코드");
                } else {
                    seen.add(item[assetKey]);
                }
                
                for (let key in fieldRules) {
                    const errordata =  await validate(item[key], fieldRules[key]);
                    if (errordata.length > 0) {
                        const inputdata =item[assetKey] +" -> "+ key + " : "+ errordata[0];
                        errormsg.push(inputdata);
                    }
                }
            }

            if(errormsg.length > 0) {
                return errormsg;
            }

            return "";
        }
        
        checkData().then(errormsg => {
            if(errormsg.length > 0 || errormsg != "") {
                alert("다음과 같은 입력 오류가 발생\n---------------------------------------\n"+errormsg.join("\n"));
                return;
            }

            // 파일 Key값 체크
            if(parsedData.find(isKeyCheckError)) {
                //if (assetType == '') {
                //    Modal.error({title: "업로드 대상 파일의 회사가 조건과 맞지 않습니다."});
                //} else {
                    Modal.info({title: "업로드 대상 파일의 자산구분이 조건과 맞지 않습니다."});  
                //}
                return;
            }

            Modal.confirm({
                title: '기존에 등록된 자산에 추가 되거나 같은 자산이면 업데이트 됩니다.',
                content: '정말로 업로드 하시겠습니까?',
                okText: 'Yes',
                okType: 'danger',
                cancelText: 'No',
                onOk() {
                    fnUploadAssetData();
                },
            });            
        });
    };

    // 업로드
    const fnUploadAssetData = () => {
        setUploading(true);
        // if(isValidate(parsedData,"asset_cd")){ 
        //     setUploading(false);
        //     alert("자산정보에 필요한 값을 넣어주세요!"); 
        //     return;
        // }
        axios.post(postSaveAssetUpload(), {
            companyCode : companyCode,
            assetType : assetType,
            parsedData : parsedData,
          }, {logCompany : companyCode, logParam : assetTypeName})
          .then((response) => {
            setUploading(false);

            if(response.data?.status === 'success' || 
               response.data?.message === "Assets uploaded successfully" ||
               response.data?.message === "자산이 성공적으로 upload되었습니다.") 
               {
                Modal.info({title: titleName, content:"자신이 등록 되었습니다", okText:"Close", onOk() {
                    //정상적으로 생성된 경우, 부모창을 재조회하고 팝업창을 닫는다.
                    //window.close();
                    onClose?.(true);
                }});
            } else {
                Modal.info({title:titleName, content:response.data?.message, okText:"Close", onOk(){
                    onClose?.(true);
                }});  
            }
        })
        .catch((error) => {
            setUploading(false);
            let errorMsg = "자산등록에 실패하였습니다.";

            if(error.response.data.error) {
                errorMsg = error.response.data.error;
            } else if(error.response.data.message) {
                errorMsg = error.responsee.data.message;
            } else if(error.message) {
                errorMsg = error.message;
            } else {
                errorMsg = error;
            }

            Modal.error({title:titleName+" 오류", content:errorMsg, okText:"Close"});
        });
    }

    const onClickCloseHandler = () => {
        //window.close();
        onClose?.(false);
    }
    //----------------------------------------------------------------------------------------
    return (
    <div className='layer_overlay'>
        {/* <div className='layer_wrap' style={{width:Math.ceil( window.innerWidth - 100 ), height:Math.ceil( window.innerHeight - 200 )}}> */}
        <div className='layer_wrap' style={{width:'90%', height:Math.ceil( window.innerHeight - 200 )}}>
            <div className='popup_header'>
            <div className='popup_title'>
                자산 등록
            </div>
            </div>
            <div className="popup_button" style={{top:'10px'}}>    
                <Button type="default" 
                    style={{marginRight: '10px'}}>
                            <CSVLink 
                                data={csv_data} 
                                headers={csv_headers} 
                                filename={'자산등록_업로드양식'}>
                                {'샘플 다운'}
                            </CSVLink>
                </Button>
                <input
                    type="file"
                    name="file"
                    className='ant-btn-primary'
                    style={{padding: '4px 15px'}}
                    onChange={onChangeUploadHandler}
                    accept=".csv, .txt"
                />
                {showUpload? (
                    <Button
                        type="primary"
                        onClick={onClickSaveHandler}
                        loading={uploading}
                        style={{marginRight: '10px'}}>
                        {'저장'}
                    </Button>
                    ) : (
                        <></>
                )}
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}>
                    {'닫기'}
                </Button>
            </div>
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'10%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'10%'}} />
                        <col />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>회사</th>
                        <td>{ p_companyCode ? (
                                    <Select id="companyCode"
                                            value={companyCode}
                                            size="small"
                                            style={{width: "80%"}}
                                            disabled={true}
                                        >
                                        <Option key={companyCode} value={companyCode}>{'['+companyCode+']'} {companyName}</Option>
                                    </Select>
                                ) : (<CodeSelect codeType="com_cd" 
                                                id="companyCode"
                                                value={companyCode}
                                                disabled={p_companyCode?true:false}
                                                onChangeHandler={onChangeCompanyCode}
                                    />  
                                )}
                        </td>
                        <th>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type" 
                                        id="assetType"
                                        value={assetType}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetType}
                            />
                        </td>
                        <th></th>
                        <td></td>
                    </tr>
                    <tr>
                        <td colSpan={6}>
                            <span style={{paddingLeft: '20px', color:'#0378c7'}}>
                                ※ 샘플파일을 다운로드하시고 csv로 저장하여 사용해주세요.
                                {/* &nbsp;&nbsp;&nbsp;&nbsp;
                                ※  **표시가 있는 항목은 필수이며, (코드)의 경우에는 반드시 코드값으로 입력해야 합니다. */}
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                ※ 한글이 깨지는 경우, 유니코드 텍스트로 저장해 주세요.
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div className="section">
                <Content style={{ height: getGridTableHeight(340), backgroundColor: '#fff', overflow: 'scroll'}}>
                    <table>
                        <thead>
                        <tr>
                            {tableRows.map((rows, index) => {
                            return <th key={index}>{rows}</th>;
                            })}
                        </tr>
                        </thead>
                        <tbody>
                        {values.map((value, index) => {
                            return (
                            <tr key={index}>
                                {value.map((val, i) => {
                                return <td key={i}>{val}</td>;
                                })}
                            </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </Content>
            </div>
        </div>
    </div>
    );
}
export default AssetUpload;